import type { ReactNode } from 'react';
import classNames from 'classnames';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAppContext } from '@/Main';

type RouteItem = {
  name: string;
  to?: string;
  active?: boolean;
};

type NavbarNavLinkProps = {
  title?: ReactNode;
  label?: string;
  route?: RouteItem;
};

const NavbarNavLink = ({ title, route }: NavbarNavLinkProps) => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig
  } = useAppContext();

  const handleClick = () => {
    if (route?.name === 'Modal') {
      setConfig('openAuthModal', true);
    }
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  return (
    <Nav.Link
      as={title ? 'p' : Link}
      className={classNames('fw-medium', {
        'text-500': !route?.active,
        'text-700 mb-0 fw-bold': title,
        'py-1': !title,
        'link-600': !title && route?.active
      })}
      to={route?.to}
      onClick={handleClick}
    >
      {title ? title : route?.name}
    </Nav.Link>
  );
};

export default NavbarNavLink;
